import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Headline = styled.div(
  ({theme}) => css`
    color: ${theme.colors.contentInversePrimary};
    /*  Custom  typography */
    font: 700 1.375rem / 1.75rem 'Open Sans';
  `
);
